export default {
  namespaced: true,
  state: {
    token: null,
    loadingPrescriber: false,
    attributes: {},
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setLoadingPrescriber(state, loadingPrescriber) {
      state.loadingPrescriber = loadingPrescriber
    },
    setData(state, attributes) {
      state.attributes = attributes
    },
  },

  getters: {
    token: state => state.token,
  },
}
